import { ActivityInput } from '../../../graphql/generated/graphql.ts';
import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { getDay } from 'date-fns';

export interface CancelAndPlanProps {
  input: Partial<ActivityInput>;
  onNext: (input: Partial<ActivityInput>) => void;
}

export const CancelAndPlan: FC<CancelAndPlanProps> = ({ input, onNext }) => {
  const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const today = getDay(new Date());

  return (
    <Stack>
      <Typography variant="h4" sx={{ my: 2 }}>
        Cancel Future Activities & Plan New One
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        This will remove upcoming activities and let you plan a new one.
      </Typography>
      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onNext({
              ...input,
              schedule: input.schedule?.filter((schedule) => {
                return weekDays.findIndex((d) => d === schedule.day) <= today - 1;
              })
            });
          }}
        >
          Cancel Future Activities & Plan a New One
        </Button>
      </Stack>
    </Stack>
  );
};
